//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const FormEditSubmissionSearch: FeatureFlag = {"Id":"FormEditSubmissionSearch","Label":"Show links to Submission Search in the Form Editor","Impact":"Shows a link in the top nav that allow going to the Submission Search with this form pre-selected","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
